import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Link } from '../../../core/models/link.model';

@Component({
    selector: 'ca-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
    @Input() link: Link;
}
